import { Directive, HostListener } from '@angular/core';

/**
 * This is added to popovers that are not children
 * of the output to prevent scrolling.
 */
@Directive({
  selector: '[h3ScrollDisabler]',
  standalone: false,
})
export class ScrollDisablerDirective {
  @HostListener('wheel', ['$event']) handleScrollEvent(event: WheelEvent) {
    event.preventDefault();
  }
}
